// Token 的 key
const TOKEN_KEY = 'user_token'
const USER_INFO_KEY = 'user_info'

// 获取 token
export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

// 设置 token
export function setToken(token:any) {
  localStorage.setItem(TOKEN_KEY, token)
}

// 移除 token
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_INFO_KEY)
}

// 获取用户信息
export function getUserInfo() {
  const info = localStorage.getItem(USER_INFO_KEY)
  return info ? JSON.parse(info) : null
}

// 设置用户信息
export function setUserInfo(userInfo:object) {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
}

// 检查是否登录
export function isLoggedIn() {
  return !!getToken()
}

// 清除所有认证信息
export function clearAuth() {
  removeToken()
}